module.exports = __webpack_public_path__ + "static/media/top_left_sparkles.da1840a3.png";